<template>
  <div>
    <p class="m-t-15 font-size-13">
      {{ $t("Enter your account information and the new password") }}
    </p>
    <div class="mb-3">
      <form @submit.prevent="reset" class="submit">
        <div class="form-group mb-3">
          <label>{{ $t('E-mail') }}</label>
          <input
            class="form-control"
            id="email"
            required
            type="text"
            :value="maskedEmail"
            disabled
            readonly
          />
        </div>
        <form-password-validator
          v-model="resetForm.password"
          :label="$t('Password')"
          :placeholder="$t('Password')"
          :required="true"
          @valid="passwordValid = $event"
        />
        <form-password-validator
          v-model="resetForm.password_confirmation"
          :label="$t('Confirm password')"
          :placeholder="$t('Confirm password')"
          :required="true"
          :show-requirements="false"
          :match-password="resetForm.password"
        />
        <div class="form-group text-right">
          <button
            class="btn btn-primary btn-submit pl-5 pr-5"
            data-style="zoom-in"
            type="submit"
            :disabled="!passwordValid || resetForm.password !== resetForm.password_confirmation"
          >
            {{ $t("Reset password") }}
          </button>
        </div>
      </form>
    </div>
    <div class="m-0">
      <p class="m-0">
        {{ $t("Do you already have access to your account?") }}
        <router-link to="/auth/login">{{ $t("Login") }}</router-link>
      </p>
    </div>
  </div>
</template>

<script>
import FormPasswordValidator from '../../../components/form/FormPasswordValidator';

export default {
  name: "Reset",
  components: {
    FormPasswordValidator
  },
  metaInfo() {
    return {
      title: this.$i18n.t("Recover account"),
    };
  },
  data() {
    return {
      resetForm: {
        token: null,
        email: null,
        password: null,
        password_confirmation: null,
      },
      passwordValid: false
    };
  },
  computed: {
    maskedEmail() {
      if (!this.resetForm.email) return '';
      
      const email = this.resetForm.email;
      const [username, domain] = email.split('@');
      
      if (!username || !domain) return email;
      
      const firstChar = username[0];
      const lastChar = username[username.length - 1];
      const maskedUsername = firstChar + '*'.repeat(username.length - 2) + lastChar;
      
      return `${maskedUsername}@${domain}`;
    }
  },
  mounted() {
    this.resetForm.token = this.$route.params.token;
    this.resetForm.email = this.$route.query.email || '';
  },
  methods: {
    reset() {
      if (!this.passwordValid) {
        return;
      }

      if (this.resetForm.password !== this.resetForm.password_confirmation) {
        swal.fire(this.$t("Error"), this.$t("As senhas não coincidem"), "warning");
        return;
      }

      let ladda = Ladda.create(document.querySelector(".btn-submit"));
      ladda.start();
      axios
        .post("api/auth/reset", this.resetForm)
        .then((response) => {
          this.$store.commit("login", response.data.data);
          this.$router.push("/dashboard/home");
          ladda.stop();
        })
        .catch(() => {
          this.resetForm.password = null;
          this.resetForm.password_confirmation = null;
        });
    },
  },
};
</script>
